import React from 'react';

import Button from 'common/components/Button';
import propTypes from 'prop-types';
import { TranslatedMessage } from 'common/components/Intl';
import * as paths from 'apps/cart/paths';

export default class CheckoutButton extends React.Component {
  static propTypes = {
    lineItemsProcessing: propTypes.array.isRequired,
    itemQuantity: propTypes.number.isRequired,
    hasViolations: propTypes.bool.isRequired,
    numOfSubscribableItemsReqToCheckout: propTypes.number.isRequired,
  };

  setWindowLocation = () => {
    const { numOfSubscribableItemsReqToCheckout } = this.props;
    const url =
      numOfSubscribableItemsReqToCheckout > 0
        ? paths.shopPods()
        : paths.checkout();
    window.location.assign(url);
  };

  get buttonText() {
    const remainingPods = this.props.numOfSubscribableItemsReqToCheckout;
    if (remainingPods > 0) {
      return (
        <TranslatedMessage
          id={'cart.checkout_button.add_remaining'}
          values={{ count: remainingPods }}
        />
      );
    }
    return <TranslatedMessage id={'cart.checkout_button.proceed'} />;
  }

  render() {
    const { itemQuantity, lineItemsProcessing, hasViolations } = this.props;

    const isEmpty = itemQuantity === 0;
    const isProcessing = lineItemsProcessing.length > 0;
    const checkoutDisabled = isEmpty || isProcessing || hasViolations;

    const buttonProps = {
      processing: isProcessing,
      disabled: checkoutDisabled,
      className: 'cart-ledger__checkout button--full-width',
      onClick: this.setWindowLocation,
    };
    return <Button {...buttonProps}>{this.buttonText}</Button>;
  }
}
